import { useHomePageController } from '@controllers/useHomePageController';
import HomePageView from '@views/pages/HomePageView';

export default function HomePage() {
  return <HomePageView {...useHomePageController()} />;
}
